import { render } from "./signedIndexComponent.vue?vue&type=template&id=38e6e6e8"
import script from "./signedIndexComponent.vue?vue&type=script&lang=js"
export * from "./signedIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__